import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withModifiers as _withModifiers, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = { class: "geofencing-view" }
const _hoisted_2 = {
  key: 0,
  class: "row ms-0 me-0 p-0 geofencing-layout"
}
const _hoisted_3 = { class: "col-md-4 pt-4 position-relative geofencing-position-list-section" }
const _hoisted_4 = { class: "float-left" }
const _hoisted_5 = {
  key: 0,
  class: "mt-15"
}
const _hoisted_6 = {
  key: 1,
  class: "table table-bordered mt-15"
}
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "ps-2 pe-2" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = {
  key: "element",
  class: "col-12 position-absolute top-0 h-100 pe-4 m-geofencing"
}
const _hoisted_11 = { class: "m-geofencing__title" }
const _hoisted_12 = { class: "m-geofencing__content" }
const _hoisted_13 = {
  class: "control-label",
  for: "geofencing-name"
}
const _hoisted_14 = {
  key: 0,
  class: "vuelidate-errors"
}
const _hoisted_15 = { class: "error-msg" }
const _hoisted_16 = { class: "btn btn-primary" }
const _hoisted_17 = {
  class: "col-md-8 pe-0 position-relative geofencing-map-section",
  id: "geofencing-map-section"
}
const _hoisted_18 = {
  ref: "geofencingMap",
  class: "geofencing-map",
  id: "geofencing-map"
}
const _hoisted_19 = {
  key: 0,
  class: "geofencing-toolbar"
}
const _hoisted_20 = {
  key: 1,
  class: "row ms-0 me-0 geofencing-events-layout"
}
const _hoisted_21 = { class: "col-md-12 pt-4 position-relative" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_GeoFencingEvents = _resolveComponent("GeoFencingEvents")!
  const _component_Tabs = _resolveComponent("Tabs")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Tabs, null, {
      "tab-selector": _withCtx(() => [
        _createElementVNode("button", {
          class: _normalizeClass([{active: _ctx.tabContent === _ctx.TAB_GEOFENCING }, "tab-link"]),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setTab(_ctx.TAB_GEOFENCING)))
        }, " Geofencing ", 2),
        _createElementVNode("button", {
          class: _normalizeClass([{active: _ctx.tabContent === _ctx.TAB_GEOFENCING_EVENTS }, "tab-link"]),
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setTab(_ctx.TAB_GEOFENCING_EVENTS)))
        }, " Zdarzenia ", 2)
      ]),
      "tab-content": _withCtx(() => [
        (_ctx.tabContent === _ctx.TAB_GEOFENCING)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("h4", _hoisted_4, _toDisplayString(_ctx.$t('geofencing.itemsTitle')), 1),
                _createElementVNode("i", {
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.toggleCrud && _ctx.toggleCrud(...args))),
                  class: "bi bi-plus btn btn-primary btn-sm float-right fs-2 ps-2 pe-2 pt-0 pb-0"
                }),
                (_ctx.items.length === 0)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(_ctx.$t('geofencing.itemsEmpty')), 1))
                  : _createCommentVNode("", true),
                (_ctx.items.length > 0)
                  ? (_openBlock(), _createElementBlock("table", _hoisted_6, [
                      _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item) => {
                          return (_openBlock(), _createElementBlock("tr", {
                            key: item.id,
                            onClick: ($event: any) => (_ctx.viewGeometry(item)),
                            class: "cursor-pointer"
                          }, [
                            _createElementVNode("td", _hoisted_8, _toDisplayString(item.name), 1),
                            _createElementVNode("td", {
                              class: "w-20px ps-3 pe-3 text-center",
                              onClick: ($event: any) => (_ctx.viewItem(item))
                            }, [...(_cache[12] || (_cache[12] = [
                              _createElementVNode("i", { class: "bi bi-pencil-square cursor-pointer" }, null, -1)
                            ]))], 8, _hoisted_9)
                          ], 8, _hoisted_7))
                        }), 128))
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createVNode(_Transition, {
                  name: "fade",
                  mode: "out-in"
                }, {
                  default: _withCtx(() => [
                    (_ctx.isOpen)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                          _createElementVNode("form", {
                            onSubmit: _cache[7] || (_cache[7] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitForm && _ctx.submitForm(...args)), ["prevent"]))
                          }, [
                            _createElementVNode("h4", _hoisted_11, _toDisplayString(_ctx.isEdit ? _ctx.$t('geofencing.editTitle') : _ctx.$t('geofencing.addTitle')), 1),
                            _createElementVNode("button", {
                              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.toggleCrud && _ctx.toggleCrud(...args))),
                              class: "m-geofencing__close close",
                              type: "button"
                            }, [...(_cache[13] || (_cache[13] = [
                              _createElementVNode("i", { class: "fas fa-times" }, null, -1)
                            ]))]),
                            _createElementVNode("div", _hoisted_12, [
                              _createElementVNode("label", _hoisted_13, _toDisplayString(_ctx.$t('geofencing.fieldName')), 1),
                              _withDirectives(_createElementVNode("input", {
                                class: "form-control mb-5",
                                id: "geofencing-name",
                                type: "text",
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.name) = $event)),
                                onInput: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.validate && _ctx.validate(...args)))
                              }, null, 544), [
                                [_vModelText, _ctx.formData.name]
                              ]),
                              (_ctx.validationError)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                    _createElementVNode("p", _hoisted_15, _toDisplayString(_ctx.$t('geofencing.errorMessage')), 1)
                                  ]))
                                : _createCommentVNode("", true),
                              _createElementVNode("button", _hoisted_16, [
                                _cache[14] || (_cache[14] = _createElementVNode("i", { class: "fa fa-save" }, null, -1)),
                                _createTextVNode(_toDisplayString(_ctx.$t('components.vehicles.modals.save')), 1)
                              ]),
                              (_ctx.isEdit)
                                ? (_openBlock(), _createElementBlock("a", {
                                    key: 1,
                                    class: "btn btn-danger float-right",
                                    onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.removeItem(_ctx.id)))
                                  }, [
                                    _cache[15] || (_cache[15] = _createElementVNode("i", { class: "fa fa-remove" }, null, -1)),
                                    _createTextVNode(_toDisplayString(_ctx.$t('components.sentGeo.dataGrids.delete')), 1)
                                  ]))
                                : _createCommentVNode("", true)
                            ])
                          ], 32)
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, null, 512),
                (_ctx.drawControlsMenu)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                      _createElementVNode("button", {
                        type: "button",
                        class: _normalizeClass({active: _ctx.drawMode === 'polygon'}),
                        onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.startDraw('polygon')))
                      }, [...(_cache[16] || (_cache[16] = [
                        _createElementVNode("i", { class: "bi bi-pentagon" }, null, -1)
                      ]))], 2),
                      _createElementVNode("button", {
                        type: "button",
                        class: _normalizeClass({active: _ctx.drawMode === 'rectangle'}),
                        onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.startDraw('rectangle')))
                      }, [...(_cache[17] || (_cache[17] = [
                        _createElementVNode("i", { class: "bi bi-square" }, null, -1)
                      ]))], 2),
                      _createElementVNode("button", {
                        type: "button",
                        class: _normalizeClass({active: _ctx.drawMode === 'circle'}),
                        onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.startDraw('circle')))
                      }, [...(_cache[18] || (_cache[18] = [
                        _createElementVNode("i", { class: "bi bi-circle" }, null, -1)
                      ]))], 2),
                      _createElementVNode("button", {
                        type: "button",
                        class: "geofencing-toolbar__delete",
                        onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.deleteDrawn && _ctx.deleteDrawn(...args)))
                      }, [...(_cache[19] || (_cache[19] = [
                        _createElementVNode("i", { class: "bi bi-trash" }, null, -1)
                      ]))])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.tabContent === _ctx.TAB_GEOFENCING_EVENTS)
          ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, [
                _createVNode(_component_GeoFencingEvents, { items: _ctx.items }, null, 8, ["items"])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}